import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-wrap w-full" }
const _hoisted_3 = { class: "mt-3 flex items-center justify-center gap-4" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center text-xs font-semibold uppercase tracking-wide text-gray-500 p-1\">Dom</div><div class=\"text-center text-xs font-semibold uppercase tracking-wide text-gray-500 p-1\">Seg</div><div class=\"text-center text-xs font-semibold uppercase tracking-wide text-gray-500 p-1\">Ter</div><div class=\"text-center text-xs font-semibold uppercase tracking-wide text-gray-500 p-1\">Qua</div><div class=\"text-center text-xs font-semibold uppercase tracking-wide text-gray-500 p-1\">Qui</div><div class=\"text-center text-xs font-semibold uppercase tracking-wide text-gray-500 p-1\">Sex</div><div class=\"text-center text-xs font-semibold uppercase tracking-wide text-gray-500 p-1\">Sáb</div>", 7)
const _hoisted_14 = ["onClick", "title"]
const _hoisted_15 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center"
}
const _hoisted_16 = { class: "flex items-center gap-2 bg-white border border-gray-200 rounded-full shadow-md px-4 py-2 text-sm font-medium text-gray-600" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-wrap gap-x-4 gap-y-1 mt-3 text-xs text-gray-600"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "flex items-center gap-1.5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "inline-block w-3 h-3 rounded bg-white border border-gray-300" }),
  /*#__PURE__*/_createTextVNode(" Disponível ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "flex items-center gap-1.5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "inline-block w-3 h-3 rounded bg-yellow-100 border border-yellow-300" }),
  /*#__PURE__*/_createTextVNode(" Sem vagas ")
], -1)
const _hoisted_20 = { class: "flex items-center gap-1.5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "flex items-center gap-1.5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "inline-block w-3 h-3 rounded bg-gray-50 border border-gray-200" }),
  /*#__PURE__*/_createTextVNode(" Sem expediente ou bloqueado ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_input = _resolveComponent("select-input")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.usuario_local_recebimento_graos)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`w-full ${_ctx.usaJanelas ? 'md:w-1/2' : 'md:w-1/3'}`)
          }, [
            _createVNode(_component_select_input, {
              name: "quantidade_registros",
              label: "Quantidade",
              tclass: "w-full",
              items: _ctx.quantidadeRegistros
            }, null, 8, ["items"])
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.usaJanelas)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(`w-full ${_ctx.usuario_local_recebimento_graos ? 'md:w-1/3' : 'md:w-1/2'}`)
          }, [
            _createVNode(_component_input_text, {
              label: "Previsão horário de chegada",
              name: "previsao_horario_chegada",
              tclass: "w-full",
              type: "time"
            })
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.usaJanelas)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(`w-full ${_ctx.usuario_local_recebimento_graos ? 'md:w-1/3' : 'md:w-1/2'}`)
          }, [
            _createVNode(_component_select_input, {
              name: "periodo",
              label: "Período",
              tclass: "w-full",
              items: [
            { name: 'Selecione...', value: '' },
            { name: 'Manhã', value: 1 },
            { name: 'Tarde', value: 2 },
            { name: 'Noite', value: 3 },
          ]
            }, null, 8, ["items"])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dataRef = _ctx.subMonths(_ctx.dataRef, 1))),
        type: "button",
        disabled: _ctx.carregandoDisponibilidade,
        class: "w-10 h-10 flex items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 rounded-full shadow-sm transition-colors duration-150 text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed",
        "aria-label": "Mês anterior"
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
      ], 8, _hoisted_4),
      _createElementVNode("span", {
        class: _normalizeClass(["text-lg md:text-xl font-semibold tracking-wide uppercase text-center", `text-${_ctx.theme}-900`])
      }, _toDisplayString(_ctx.formatDate(_ctx.dataRef, "MMMM")) + " de " + _toDisplayString(_ctx.formatDate(_ctx.dataRef, "yyyy")), 3),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataRef = _ctx.addMonths(_ctx.dataRef, 1))),
        type: "button",
        disabled: _ctx.carregandoDisponibilidade,
        class: "w-10 h-10 flex items-center justify-center bg-white border border-gray-300 hover:bg-gray-100 rounded-full shadow-sm transition-colors duration-150 text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed",
        "aria-label": "Próximo mês"
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
      ], 8, _hoisted_5)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["p-2 my-4 text-sm font-medium rounded-lg border flex justify-center items-center gap-2", `bg-${_ctx.theme}-50 text-${_ctx.theme}-900 border-${_ctx.theme}-200`])
    }, [
      _createVNode(_component_font_awesome_icon, { icon: "calendar" }),
      _createTextVNode(" Data selecionada: " + _toDisplayString(_ctx.getDataPorExtenso(_ctx.dataRef)), 1)
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["grid grid-cols-7 gap-1 md:gap-2 items-center transition-opacity duration-200", _ctx.carregandoDisponibilidade ? 'opacity-40 pointer-events-none' : ''])
      }, [
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrDias, (dia) => {
          return (_openBlock(), _createElementBlock("button", {
            type: "button",
            onClick: ($event: any) => (!_ctx.naoPodeAgendar(dia) ? _ctx.handleClickDia(dia) : () => {}),
            key: dia,
            title: _ctx.tituloDoDia(dia),
            class: _normalizeClass(_ctx.classesDoDia(dia)),
            style: _normalizeStyle(
          dia == 1 && _ctx.diaInicialSemana > 1
            ? ` grid-column-start: ${
                _ctx.diaInicialSemana == 8 ? 1 : _ctx.diaInicialSemana
              }; `
            : ''
        )
          }, _toDisplayString(`${dia}`.padStart(2, "0")), 15, _hoisted_14))
        }), 128))
      ], 2),
      (_ctx.carregandoDisponibilidade)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_component_font_awesome_icon, {
                icon: "sync-alt",
                spin: "",
                class: _normalizeClass(`text-${_ctx.theme}-800`)
              }, null, 8, ["class"]),
              _createTextVNode(" Carregando disponibilidade... ")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.usaJanelas)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, [
            _createElementVNode("span", {
              class: _normalizeClass(["inline-block w-3 h-3 rounded border", `bg-${_ctx.theme}-800 border-${_ctx.theme}-800`])
            }, null, 2),
            _createTextVNode(" Selecionado ")
          ]),
          _hoisted_21
        ]))
      : _createCommentVNode("", true)
  ]))
}